export default __webpack_public_path__ + "static/media/wreckingball-squeaks.59935b49.mp3";